import TrainerCalendar from "../AdminSchedule/TrainerCalendar";
import { useAdminHubUi } from "../../../hooks/useAdminAppMode";
import s from "../clinic.module.css";
import aa from "../AdminPortal/adminApp.module.css";

export default function StaffScheduleTab() {
  const mobileHub = useAdminHubUi();

  if (!mobileHub) {
    return <TrainerCalendar staffMode />;
  }

  return (
    <div className={`${s.scheduleHub} ${aa.scheduleHubApp}`}>
      <div className={s.scheduleHubContent}>
        <TrainerCalendar staffMode />
      </div>
    </div>
  );
}
